// extracted by mini-css-extract-plugin
export default {"icon":"mon-ij5Hr5TY"};